import { Col, Row, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import * as consultantReducer from "../Redux/Consultant/reducer";

import Feedback from "../Utilities/Feedback";
import JobCard from "../Utilities/JobCard";
import Pagination from "../Utilities/Pagination";
import { LoadingOutlined } from "@ant-design/icons";
import constants from "../Redux/constants";
import SearchBar from "../Utilities/SearchBar";
import SearchJobs from "../Utilities/SearchJobs";
import { Helmet } from "react-helmet";
import ConsultantProfileCompletion from "./Profile/ConsultantProfileCompletion";

const HomeContent = (props) => {
  const [page, setPage] = useState(0);
  const [loadingJobs, setLoadingJobs] = useState(true);
  const [isSearching, setIsSearching] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [fetchingNextPage, setFetchingNextPage] = useState(false);
  const { getAllJobs } = props;
  const { allJobs, totalJobsCount } = useSelector(
    (state) => state.consultantStore
  );
  const getPage = (page) => {
    setPage(page - 1);
    setFetchingNextPage(true);
    setTimeout(() => {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }, 500);
  };
  useEffect(() => {
    const fetchAllJobs = async () => {
      const { responseStatus } = await getAllJobs(page);
      if (responseStatus === constants.status.success) {
        setLoadingJobs(false);
        setFetchingNextPage(false);
      }
    };
    fetchAllJobs();
  }, [getAllJobs, page]);
  const getSearchText = async (searchText) => {
    setIsSearching(true);
    setSearchText(searchText);
  };
  const hideSearchResults = () => {
    setIsSearching(false);
  };
  return (
    <Col>
      <Helmet title="Home | Unicon"></Helmet>
      <ConsultantProfileCompletion />
      {loadingJobs ? (
        <Feedback icon={<LoadingOutlined />} title="Fetching all the jobs" />
      ) : (
        <Col>
          {allJobs.length === 0 ? (
            <Feedback status="error" title="No Jobs Found" />
          ) : (
            <Col>
              <Row justify="center">
                <Col md={{ span: 11 }} style={{ margin: "1vh" }}>
                  <SearchBar
                    searchHolder="Search Jobs"
                    getSearchText={getSearchText}
                    hideSearchResults={hideSearchResults}
                  />
                </Col>
              </Row>
              {isSearching ? (
                <Col>
                  <SearchJobs searchText={searchText} />
                </Col>
              ) : (
                <Col>
                  {fetchingNextPage ? (
                    <Col
                      md={{ span: 11 }}
                      style={{
                        padding: "1vh",
                        background: "#ffffff",
                        border: "1px solid #f4f4f4",
                        margin: "2vh",
                        marginLeft: "auto",
                        marginRight: "auto",
                        borderRadius: "2vh",
                      }}
                    >
                      {allJobs.map(() => (
                        <Skeleton active />
                      ))}
                    </Col>
                  ) : (
                    <>
                      {allJobs &&
                        allJobs.map((eachJob) => (
                          <JobCard
                            key={eachJob.jobId}
                            id={eachJob.jobId}
                            title={eachJob.title}
                            typeRequirement={eachJob.typeRequirement}
                            targetStartDate={eachJob.targetStartDate}
                            targetEndDate={eachJob.targetEndDate}
                            userId={eachJob.userId}
                            createdDate={eachJob.createdDate}
                            additionalComments={eachJob.additionalComments}
                            t24Release={eachJob.T24Release}
                          ></JobCard>
                        ))}
                    </>
                  )}

                  <Row justify="center">
                    <Col style={{ margin: "1vh" }}>
                      <Pagination
                        totalJobs={totalJobsCount}
                        getPage={getPage}
                      />
                    </Col>
                  </Row>
                </Col>
              )}
            </Col>
          )}
        </Col>
      )}
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllJobs: (page) => dispatch(consultantReducer.getAllJobs(page)),
  };
};

export default connect(null, mapDispatchToProps)(HomeContent);
